import { LmsApi } from '@services/_api/lms-api';
import { AccountSelectorService } from '@services/account-selector.service';
import {
  AuthenticationService,
  EnvConfigurationService,
} from '@services/index';

export const baseApiUrlFactory = (
  configurationService: EnvConfigurationService
) => configurationService?.config?.lmsApiUrl?.split('/api')[0];

const correctUrlIfChangingFromStudentToStaffOrVisaVersa = (
  selectedAccount: LmsApi.AuthenticateResponse
) => {
  const path = window.location.pathname;
  const pathAsArray = path.split('/');
  const isStudent = selectedAccount.role === LmsApi.Roles.Student;
  const thirdPathSegment = pathAsArray[2];

  if (pathAsArray.length <= 2) {
    return;
  }

  if (isStudent && thirdPathSegment !== 'portal') {
    const correctPath = pathAsArray[0] + '/' + pathAsArray[1] + '/' + 'portal';
    window.history.replaceState(null, '', correctPath);
  }

  if (!isStudent && thirdPathSegment !== 'admin') {
    const correctPath = pathAsArray[0] + '/' + pathAsArray[1] + '/' + 'admin';
    window.history.replaceState(null, '', correctPath);
  }
};

export const appInitializer =
  (
    envConfigService: EnvConfigurationService,
    authService: AuthenticationService,
    accountSelectorService: AccountSelectorService
  ) =>
  (): Promise<void> =>
    new Promise(async (resolve) => {
      await envConfigService.load();
      // attempt to refresh token on app start up to auto authenticate
      // at this point we may have been logged into 2 different accounts on same browser, so it will not know which to direct us to
      authService.refreshToken().subscribe(
        (res) => {
          if (res.canLogInAs.length === 0) {
            resolve();
            return;
          }

          accountSelectorService
            .chooseAccounts(res.canLogInAs)
            .then((selectedAccount?: LmsApi.AuthenticateResponse) => {
              if (!selectedAccount) {
                resolve();
                return;
              }
              // log in the selected account
              authService.loginAsSelectedAccount(selectedAccount);
              correctUrlIfChangingFromStudentToStaffOrVisaVersa(
                selectedAccount
              );

              resolve();
            });
        },
        () => {
          // Do nothing as error means the refresh token is invalid, so user will have to log in
          resolve();
        }
      );
    });
